import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { styled } from 'styled-components';
import { focusOutline } from "../../../theme/src";
import { DefaultLink } from './DefaultLink';
import { LinkSimple } from './LinkSimple';
import { getLinkStyle, ignoredPropsConfig } from '../style';
export const Link = (_a) => {
    var { children, enableWrap = false, forceDefaultLink, styledOnlyOnHover = false, to } = _a, otherProps = __rest(_a, ["children", "enableWrap", "forceDefaultLink", "styledOnlyOnHover", "to"]);
    let insideReactRouter;
    try {
        useLocation();
        insideReactRouter = true;
    }
    catch (_b) {
        insideReactRouter = false;
    }
    if (forceDefaultLink || !insideReactRouter) {
        return (_jsx(DefaultLink, Object.assign({}, otherProps, { enableWrap: enableWrap, href: typeof to === 'string' ? to : undefined, styledOnlyOnHover: styledOnlyOnHover, children: children })));
    }
    return (_jsx(LinkWrapper, Object.assign({ enableWrap: enableWrap, styledOnlyOnHover: styledOnlyOnHover, to: to }, otherProps, { children: children })));
};
const LinkWrapper = styled(LinkSimple).withConfig(ignoredPropsConfig) `
  ${getLinkStyle};
  ${focusOutline};
`;
//# sourceMappingURL=Link.js.map